export const parseMcpDate = (value: string) => {
  const timestamp = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`;
  return new Date(timestamp);
};

export const formatMcpDate = (date: string | null, locale: string) => {
  if (!date) return null;
  const parsed = parseMcpDate(date);
  return Number.isNaN(parsed.getTime())
    ? null
    : new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(parsed);
};

export const isMcpDateExpired = (date: string) => {
  const timestamp = parseMcpDate(date).getTime();
  return !Number.isFinite(timestamp) || timestamp <= Date.now();
};
